import React, { forwardRef, useImperativeHandle } from 'react';
import { DataGridPremium, useGridApiRef, DataGridPremiumProps } from '@mui/x-data-grid-premium';
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';
import { CustomNoRowsOverlay } from './CustomNoRowsOverlay';

export const DataGrid = forwardRef<GridApiPremium | null, DataGridPremiumProps>(
  (props: DataGridPremiumProps, ref) => {
    const gridApiRef = useGridApiRef();
    const { sx: sxProp, ...restProps } = props;

    // Expose the gridApiRef to the parent component
    useImperativeHandle(ref, () => gridApiRef.current, [gridApiRef]);

    const mergedSx = [
      {
        '& .MuiDataGrid-columnHeaders': {
          minHeight: '36px!important',
          maxHeight: '36px!important',
          lineHeight: '36px!important',
        },
        minWidth: 0,
      },
      ...(Array.isArray(sxProp) ? sxProp : sxProp != null ? [sxProp] : []),
    ];

    return (
        <div style={{ height: 'calc(100vh - 210px)', width: '100%', minWidth: 0 }}>
          <DataGridPremium
            {...restProps}
            sx={mergedSx}
            disableAggregation={true}
            apiRef={gridApiRef}
            hideFooterRowCount={true}
            disableRowSelectionOnClick={true}
            slots={{ noRowsOverlay: CustomNoRowsOverlay }}
          />
        </div>
    );
  },
);
